import actionTypes from '../actions/types';

export const INITIAL_STATE = {
  sendSmsStatus: false,
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_SEND_SMS_STATUS:
      return { ...state, sendSmsStatus: action.data };
    default:
      return state;
  }
};
